module.exports = __webpack_public_path__ + "img/product_info_painter.498677df.png";